import React from 'react';
import { Button, Text, View } from "../../Components/Themed"
import { Checkbox } from '../../Components';
import { useColors } from '../../constants/useColors';

type DisclaimerProps = {
    checked: boolean,
    onCheck: (checked: boolean) => void,
    onClose: () => void
}

const DisclaimerBox = ({ checked, onCheck, onClose }:DisclaimerProps) => {
    const Colors = useColors()
    return (
        <View float>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                <Text theme='h1'>Transaction Disclaimer</Text>
            </View>
            <View type='body' style={{ padding:10 }}>
                <Button style={{ padding:0, flexDirection:'row', alignItems:'flex-start' }} onPress={() => onCheck(!checked)}>
                    <Checkbox
                        checked={checked}
                        disabled
                        onSelect={() => console.log('')}
                    />
                    <View transparent style={{ flex:1, marginLeft:15 }}>
                        <Text theme='h2'>I confirm that I am the authorized user of this payment method and consent to this transaction. I understand this action is final and non-refundable. I acknowledge that I understand and agree to the Terms and Conditions I accepted when setting up my account.</Text>
                        <Text style={{ marginTop:25 }} theme='h2'>I acknowledge that my identity has been verified via government-issued ID, and I accept the BettorEdge Terms of Service and all applicable rules related to transactions and real-money platform activity.</Text>
                        <Text style={{ marginTop:25 }} theme='h2' color={Colors.text.warning} size={14}>I further understand that any chargeback will be treated as fraud and pursued to the fullest extent of the law. GPS location, device ID, IP address, and biometric verification will be logged and submitted as evidence in any dispute.</Text>
                    </View>
                </Button>
            </View>
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                <Button
                    title='CANCEL'
                    type='error'
                    style={{ flex:1, marginRight:4}}
                    onPress={() => onClose()}
                />
                <Button
                    title='CONFIRM'
                    type='success'
                    disabled={!checked}
                    style={{ flex:3, opacity: checked?1:0.5 }}
                    onPress={() => onClose()}
                />
            </View>
        </View>
    )
}

export default DisclaimerBox